module.exports = __webpack_public_path__ + "images/onvza18800cbee85f570d57ad4acb10cc75f.png";